import api from "../api";
import { ICustomizacao } from 'interfaces/Customizacao';
import { IBuscaCustomRequest } from './types';

export const buscaCustomService = async (data: IBuscaCustomRequest) => await api.get<ICustomizacao>(`busca-custom?crmId=${data.crms}&carteiraId=${data.carteiraId}`);